import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  paddingLeft: 0,
};

export const employmentType: SxStyle = {
  color: (p) => p.palette.grey[500],
  fontSize: (p) => p.typography.caption,
  whiteSpace: 'nowrap',
};
